import { AdminDashboard } from '@/components/AdminDashboard';

const AdminDashboardPage = () => {
  return <AdminDashboard />;
};

export default AdminDashboardPage;
